import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

/**
 * Affichage des pièces/score en haut de l'écran
 */
function CoinDisplay({ coins = 0, animated = false }) {
  return (
    <div className="flex items-center gap-1.5 bg-black/30 rounded-full px-3 py-1.5 border border-yellow-600/30">
      {/* Icône pièce dorée */}
      <div
        className="w-6 h-6 rounded-full flex items-center justify-center flex-shrink-0"
        style={{
          background: 'radial-gradient(circle at 35% 35%, #ffd700, #FFB81C 50%, #d4920a)',
          boxShadow: '0 0 8px rgba(255,184,28,0.5), inset 0 1px 2px rgba(255,255,255,0.4)',
        }}
      >
        {/* Étoile SVG : universel, pas de dépendance police */}
        <svg viewBox="0 0 20 20" width="13" height="13" fill="#7a5500">
          <polygon points="10,2 12.4,7.5 18.5,7.6 13.8,11.7 15.5,17.9 10,14.5 4.5,17.9 6.2,11.7 1.5,7.6 7.6,7.5" />
        </svg>
      </div>

      {/* Score */}
      <AnimatePresence mode="wait">
        <motion.span
          key={coins}
          initial={animated ? { y: -10, opacity: 0 } : false}
          animate={{ y: 0, opacity: 1 }}
          className="font-bold text-qfl-gold text-sm"
          style={{ fontFamily: "'Rajdhani', sans-serif", minWidth: '2ch' }}
        >
          {typeof coins === 'number' ? coins.toLocaleString('fr-FR') : coins}
        </motion.span>
      </AnimatePresence>
    </div>
  );
}

export default CoinDisplay;

